<div>
        <form [formGroup]="form" *ngIf="form">
            <div *ngFor="let field of formFields$ | async" class="form-row">
                <emm-dynamic-management-form-field
                    [formField]="field" [form]="form" [itemTag]="itemTag"
                    [selectedSubmenu]="selectedSubmenu"
                    [selectedLocation]="selectedLocation"
                    [nodeId]="nodeId" [itemTagPath]="this.itemTagPath"
                    [effectiveDate]="effectiveDate"
                ></emm-dynamic-management-form-field>
            </div>
        </form>
</div>
